import React from "react"

export default Object.freeze({
  all: "tous",
  "about the author": "à propos de l'auteur",
  "remove cookies": "supprimer les cookies",
  "accept cookies": "accepter les cookies",
  search: "rechercher",
  "see how we help higher education": (
    <span>
      Voir comment nous aidons <br /> l'enseignement supérieur
    </span>
  ),
  "see how we help business": (
    <span>
      Voir comment nous aidons <br /> les entreprises
    </span>
  ),
  "see what EDU customers say about us": (
    <span>
      Voir ce que les clients <br />
      EDU disent sur nous
    </span>
  ),
  "see what WORK customers say about us": (
    <span>
      Voir ce que les clients <br /> de WORK disent sur nous
    </span>
  ),
  "case study": "étude de cas",
  blog: "blog",
  industries: "secteurs",
  "case studies": "études de cas",
  resources: "ressources",
  listing: "liste",
  register: "enregistrer",
  "find out more": "en savoir plus",
  "past events": "événements passés",
  "read more": "lire plus",
  page: "page",
  previous: "précédent",
  next: "suivant",
  tip: "astuce",
  "no items found": "aucun élément trouvé",
  categories: "catégories",
  by: "par",
  events: "événement",
  "link to": "lien vers",
  oops: "Oops...",
  "page not found message": "Ce contenu n'est plus disponible, nous vous suggérons de lire sur:",
  "event passed": "l'événement est terminé",
  "business we work with": "quelques-uns des secteurs commerciaux avec lesquels nous travaillons",
  "education we work with": "quelques-uns des secteurs de l'éducation avec lesquels nous travaillons",
  "back to homepage": "retour à la page d'accueil",
  "try it free": "Essayer gratuitement",
  "book a demo": "Réserver une démonstration",
})
